<div class="p-2">
  <div class="m-1 card-wrapper {{ card.setCode }}" *ngFor="let card of cards$ | async">
    <img [src]="getImageUri(card.identifiers.scryfallId, 'small')">
  </div>
</div>
